import config from 'constants/config'
import { ChertoExperiments } from 'constants/experiments'
import { getExperimentEnabledDecision, isAllowedToTriggerExperiment } from 'lib/optimizely/optimizelyUtils'

/**
 * State-based read of whether the current user is in the treatment variant of the insurance
 * price-increase experiment (a Cherto experiment).
 *
 * Reselect selectors (and the checkout quote read-path) cannot call the `useExperiment` hook, so
 * the decision is derived directly from `state.cherto`. This mirrors useExperiment's cherto branch
 * — the UTM/GHA exclusion, the `CHERTO_<key>` local override, and the off/control normalisation —
 * so the value matches the hook's `isAnyVariant`, keeping the write (fetch hook) and read (checkout
 * selectors) quote keys identical for treatment users.
 */
export function selectInsurancePriceIncreaseIsVariant(state: App.State): boolean {
  const experimentId = ChertoExperiments.croInsurancePriceIncrease.id

  if (!isAllowedToTriggerExperiment(true, state.utm.content, experimentId)) {
    return false
  }

  // Local dev override (CHERTO_<key>) wins; otherwise use the SSR-bucketed Cherto variation.
  const override = config[`CHERTO_${experimentId}`]
  const variationKey = override ?? state.cherto?.chertoExperiments?.[experimentId]?.variationKey

  return getExperimentEnabledDecision(variationKey)
}
